import { render, staticRenderFns } from "./dataAuthority.vue?vue&type=template&id=e96b24ee&scoped=true"
import script from "./dataAuthority.vue?vue&type=script&lang=js"
export * from "./dataAuthority.vue?vue&type=script&lang=js"
import style0 from "./dataAuthority.vue?vue&type=style&index=0&id=e96b24ee&prod&scoped=true&lang=css"
import style1 from "./dataAuthority.vue?vue&type=style&index=1&id=e96b24ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96b24ee",
  null
  
)

export default component.exports